<template>
  <div class="item-recommended" v-if="recommended_data">
    <div class="cover">
      <img
        class="h-40 w-full object-cover"
        :src="getImageUrl"
        alt="demo"
      />
    </div>
    <div class="content">
      <div v-if="categoryName" class="label label-grey-200 text-primary">
        <div class="w-full one-lines-ellipsis">
          {{categoryName}}
        </div>
      </div>
      <div v-else class="label text-primary">
        <div class="w-full">
        </div>
      </div>
      <div class="item-id">
        <span>メニューNo. {{ recommended_data.menuNo }}</span>
      </div>
      <div class="item-title text-epip">
        <a @click="navigate">
          <h4>{{ recommended_data.menuNm }}</h4>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')

export default {
  name: 'RecommendedItem',
  props: ['recommended_data'],
  data() {
    return {}
  },
  computed: {
    categoryName() {
      let categoryNm = ''
      if (_.get(this.recommended_data, 'categoryInfomation.catLrgClassNm')) {
        categoryNm += _.get(this.recommended_data, 'categoryInfomation.catLrgClassNm')
      }
      if (_.get(this.recommended_data, 'categoryInfomation.catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.recommended_data, 'categoryInfomation.catMidClassNm')
      }
      if (_.get(this.recommended_data, 'categoryInfomation.catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.recommended_data, 'categoryInfomation.catSmlClassNm')
      }
      return categoryNm
    },
    getImageUrl() {
      const imageUrl = _.get(this.recommended_data, 'menuImages[0].imageUrl', null)
      if (imageUrl) {
        return imageUrl
      }
      return PLACEHOLDER_IMG
    }
  },
  methods: {
    navigate() {
      location.href = `/menus/${this.recommended_data.menuNo}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>